import React from 'react';
import FeedbackForm from './FeedbackForm';

export default function FeedbackPage() {
    return (
        <div className="container" style={{ textAlign: "center", marginTop: "50px", minHeight: "80vh" }}>
            <h1>💬 Feedback & Support</h1>
            <p style={{ color: 'var(--text-muted)', marginBottom: '30px' }}>
                We'd love to hear from you. Please share your thoughts or report any issues.
            </p>

            <div style={{ maxWidth: "600px", margin: "0 auto" }}>
                <FeedbackForm />
            </div>
        </div>
    );
}
